module.exports = __webpack_public_path__ + "static/img/7.2f1b038.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/zh/7.png
// module id = 4tSm
// module chunks = 0